import { fromJS, Map } from 'immutable';

export function request(state, { id, legs }) {
    let payouts = state.get('payouts') || Map();

    payouts = payouts.set(id, Map({
        state: 'IN_PROGRESS',
        legs
    }));

    return state.set('payouts', payouts);
}

export function error(state, { id, errors }) {
    let payouts = state.get('payouts') || Map();

    payouts = payouts.set(id, Map({
        state: 'ERROR',
        errors: fromJS(errors)
    }));

    return state.set('payouts', payouts);
}

export function finish(state, { id, payout }) {
    let payouts = state.get('payouts') || Map();

    payouts = payouts.set(id, Map({
        state: 'FINISHED',
        payout
    }));

    return state.set('payouts', payouts);
}
